import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ChartPieSlice, UsersThree, SignOut } from "@phosphor-icons/react";

const links = [
  { to: "/admin", label: "Dashboard", icon: ChartPieSlice, testid: "nav-admin-dashboard", end: true },
  { to: "/admin/users", label: "Staff Accounts", icon: UsersThree, testid: "nav-admin-users" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-40 bg-primary border-b border-primary text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 shrink-0">
            <div className="bg-white rounded-lg px-2.5 py-1.5 shadow-sm">
              <img src="/mcr-logo.png" alt="Mobile Crisis 24/7 Services" className="h-6 sm:h-7 w-auto" />
            </div>
            <div className="hidden sm:block leading-none">
              <p className="font-heading font-extrabold text-[15px]">Admin Console</p>
              <p className="text-[11px] text-white/60 tracking-wide">Cyber Security Training</p>
            </div>
          </div>

          <nav className="flex items-center gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                data-testid={l.testid}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-3.5 py-2 rounded-full text-sm font-medium transition-colors duration-200 ${
                    isActive ? "bg-white text-primary" : "text-white/80 hover:bg-white/10"
                  }`
                }
              >
                <l.icon size={18} weight="duotone" />
                <span className="hidden sm:inline">{l.label}</span>
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3 shrink-0">
            <span className="hidden sm:block text-sm text-white/70">{user?.email}</span>
            <button
              onClick={handleLogout}
              data-testid="logout-button"
              className="flex items-center gap-1.5 text-sm text-white hover:text-accent transition-colors duration-200 font-medium"
            >
              <SignOut size={18} weight="duotone" /> Log out
            </button>
          </div>
        </div>
      </header>

      <main>
        <Outlet />
      </main>
    </div>
  );
}
